import type { Person } from '../domain/types.js';

/**
 * Portion factors sum to 3.1, NOT 5.
 *
 * Two adults at 1.0, Ezra (5) at 0.5, and the 2.5-year-old twins at 0.3 each.
 * Cooking for "five people" over-buys by roughly 40% every week. Raise these as
 * the children grow — Ezra's will climb every year.
 *
 * lunchDays: the twins are at nursery Wednesday, Thursday and Friday and need a
 * lunch box each of those days. Ezra has hot dinners at school and needs none.
 * Six lunches a week, not fifteen.
 */
export const HOUSEHOLD: Person[] = [
  { id: 'peter',   name: 'Peter',   personType: 'adult', portionFactor: 1.0, lunchDays: [] },
  { id: 'emily',   name: 'Emily',   personType: 'adult', portionFactor: 1.0, lunchDays: [] },
  { id: 'ezra',    name: 'Ezra',    personType: 'child', portionFactor: 0.5, lunchDays: [] },
  { id: 'phoenix', name: 'Phoenix', personType: 'child', portionFactor: 0.3, lunchDays: ['wed', 'thu', 'fri'] },
  { id: 'ava',     name: 'Ava',     personType: 'child', portionFactor: 0.3, lunchDays: ['wed', 'thu', 'fri'] },
];
